<template>
    <div>Unfind</div>
</template>

<script>
export default {
    name: `Unfind`
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Unfind.vue